module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA4UlEQVQ4ja3UMQ4BQRjF8beJCyjpJLJqEoVGthUn0OgkKokDcAAJZ6BTSBQO4AI6jcoFFBIX+CvYGGN2drEvmWSS781vN1NMACinlCVFAvJYHZ7JA1vwSuMfqAQcDCwE9CvWBm7mn8WzX7A+7+ma82+xkYWN7U68qQO9FGxiYWtXT8DAKM0TsKmFnZM+LGBrlfdA0SiN+UzVBwpYWgcuQAWIHNjHvblAASvHYTtHH2aD4nHRvoTfggI2CdgsDUsCXeg1C+YDBewMcJgVDMD7Hp4k1SQFWR/FQsq8JamZFZOkOwPf2M/C7Yf9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/operationFlow/duigou.png
// module id = Z9So
// module chunks = 1